import { httpRequest } from "../../http";
import type { Instructions } from "@models/instructions.model";

export class CommandGetInstructions {
  async run(definitionId: number): Promise<Instructions> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/instructions/`;
    return httpRequest<Instructions>(url, { method: "GET" });
  }
}
